/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocsPlusIcon20Solid = forwardRef('DocsPlusIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.004 1H6a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V6.998h-3.746a2.25 2.25 0 0 1-2.25-2.25V1ZM9 9.002a.75.75 0 0 1 .75.75v1.498h1.499a.75.75 0 0 1 0 1.5H9.75v1.499a.75.75 0 0 1-1.5 0V12.75H6.752a.75.75 0 0 1 0-1.5H8.25V9.752a.75.75 0 0 1 .75-.75Z" }),
        React.createElement("path", { d: "m14.863 5.498-4.359-4.359v3.609c0 .414.336.75.75.75h3.61Z" }),
        React.createElement("path", { d: "M17.563 7.5a.75.75 0 1 0-1.5 0v6.781a3.75 3.75 0 0 1-3.75 3.75H7.5a.75.75 0 0 0 0 1.5h4.813c2.899 0 5.25-2.35 5.25-5.25V7.5Z" })));
});
